import { Copy, Key, Shield } from "lucide-react";
import { toast } from "sonner";


const copyText = async (value, message) => {
  await navigator.clipboard.writeText(value);
  toast.success(message);
};


export const DeploymentCredentialsPanel = ({ apiKey, agentAdmin }) => (
  <div className="space-y-6" data-testid="deployment-credentials-panel">
    <div className="card-dark p-5 border border-red-500/30 bg-red-500/5" data-testid="deployment-api-key-card">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-lg bg-red-500/20 flex items-center justify-center flex-shrink-0">
          <Key className="w-6 h-6 text-red-400" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-red-400 mb-2">Save This API Key NOW!</h3>
          <p className="text-sm text-slate-300 mb-3">This key is embedded in the script but will not be shown again after you leave this page.</p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <code className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 font-mono text-sm text-lime-400 select-all break-all" data-testid="deployment-server-api-key">
              {apiKey}
            </code>
            <button
              onClick={() => copyText(apiKey, "API key copied")}
              className="btn-primary flex items-center justify-center gap-2"
              data-testid="copy-deployment-server-api-key"
            >
              <Copy className="w-4 h-4" />
              Copy Key
            </button>
          </div>
        </div>
      </div>
    </div>

    {agentAdmin && (
      <div className="card-dark p-5 border border-cyan-500/30 bg-cyan-500/5" data-testid="deployment-agent-admin-credentials">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-cyan-500/20 flex items-center justify-center flex-shrink-0">
            <Shield className="w-6 h-6 text-cyan-400" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Save the Local Agent Admin Login</h3>
            <p className="text-sm text-slate-400 mb-3">The password is stored only as a secure hash on the agent and will not be shown again.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <code className="bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 font-mono text-sm text-slate-200 select-all break-all" data-testid="deployment-agent-admin-username">
                {agentAdmin.username}
              </code>
              <code className="bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 font-mono text-sm text-lime-400 select-all break-all" data-testid="deployment-agent-admin-password">
                {agentAdmin.password}
              </code>
            </div>
            <button
              onClick={() => copyText(`Username: ${agentAdmin.username}\nPassword: ${agentAdmin.password}`, "Agent admin credentials copied")}
              className="btn-secondary mt-3 flex items-center gap-2 text-xs"
              data-testid="copy-deployment-agent-admin-credentials"
            >
              <Copy className="w-3 h-3" />
              Copy login
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);